<template>
  <hr-branded-form-page @submit="onLogin">
    <p>
      {{ $t('modals.encryptionModal.decryptionSubtitle') }}
    </p>
    <hr-password-field
      v-model="encryptionPassword"
      :label="$t('modals.encryptionModal.decryptionFieldLabel')"
      lazy-rules
      hide-bottom-space
      autocomplete="current-password"
      data-e2e="input-decryption-password"
    />

    <template #actions>
      <hr-confirm-btn
        type="submit"
        :label="$t('modals.encryptionModal.decryptionUnlockBtn')"
        data-e2e="button-unlock-decryption"
      />
      <hr-subtle-btn
        :label="$t('login.buttonForgotPassword')"
        @click="onResetDecryptionPassword"
      />
    </template>

    <template #footer>
      <span>{{ currentRegionLabel }}</span>
      <span>Version: {{ version }}</span>
    </template>
  </hr-branded-form-page>
</template>

<script>
import { mapActions, mapState } from 'pinia';
import { HrBrandedFormPage, HrConfirmBtn, HrPasswordField, HrSubtleBtn } from 'src/design-system';
import Interactions from 'src/mixins/Interactions';
import { auth } from 'src/store/auth';
import { region } from 'src/store/region';
import { decryptPrivateKey, readEncryptionPassword } from 'src/utils/CryptoUtils';
import { clearLocalData } from 'src/utils/OfflineAccessUtils';

export default {
  name: 'Encryption',

  components: { HrBrandedFormPage, HrConfirmBtn, HrPasswordField, HrSubtleBtn },

  mixins: [Interactions],

  data() {
    return {
      encryptionPassword: '',
    };
  },

  computed: {
    ...mapState(region, ['currentRegionLabel']),

    version: () => process.env.version,
  },

  async mounted() {
    const encryptionPassword = await readEncryptionPassword();

    if (encryptionPassword) {
      this.encryptionPassword = encryptionPassword;
      this.onLogin();
    }
  },

  methods: {
    ...mapActions(auth, ['handleAuthStateChanged']),

    onLogin() {
      this.onDecryptPrivateKey();
    },

    async onDecryptPrivateKey() {
      const isSuccessful = await decryptPrivateKey(this.encryptionPassword);
      if (!isSuccessful) {
        this.notifyNegative(this.$t('login.notifyWrongDecryptionPasswordError'));
        return;
      }
      await this.handleAuthStateChanged({ context: this });

      this.$router.push({ name: 'Home' });
    },

    onResetDecryptionPassword() {
      this.confirmDialog(
        this.$t('modals.offlineModal.resetOfflinePasswordTitle'),
        this.$t('modals.offlineModal.resetOfflinePasswordSubtitle'),
        async () => {
          await clearLocalData();
          await this.handleAuthStateChanged({ context: this });
          this.$router.push({ name: 'Home' });
        },
      );
    },
  },
};
</script>
